/* SiteSelector.tsx generated by @compiled/babel-plugin v0.36.0 */
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { ax, ix, CC, CS } from "@compiled/react/runtime";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { media } from '@atlaskit/primitives';
import { AppInstallPermission } from '@atlassian/mpac-services-client';
import { MarketplaceAppPaymentModel } from '@atlassian/mpac-types/client-graphql-schema-types';
import { InstallableAppPrivacyInformation } from '@atlassian/mpac-ui';
import { useOneClickInstallSiteSelector } from '../../../hooks';
import { getInstallCTALabelAndHref } from '../OneClickAppInstallDialog.util';
import { SiteSelectorFooter } from './SiteSelectorFooter';
import { SiteSelectorSelect } from './SiteSelectorSelect';
import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
const _7 = "@media (min-width:64rem){._1yagcwrd{padding:var(--_1ocxs6l)}}";
const _6 = "._1yt41ejb{padding:var(--ds-space-300,24px)}";
const _5 = "@media (min-width:64rem){._10m4frkr{flex-grow:0.6}._1vdkkb7n{flex-shrink:1}._1wznf1ug{flex-basis:0%}._zp8115vq{overflow-x:hidden}._1mbp15vq{overflow-y:hidden}._2oz42wrg{border-radius:var(--_7ouv5q)}._ue5gf5zk{margin:var(--_1kctt8h)}._4ap3r01l{background-color:var(--ds-background-input-pressed,#fff)}}";
const _4 = "._1bah1yb4{justify-content:space-between}";
const _3 = "._4t3ioskh{height:calc(100% - 24px)}";
const _2 = "._2lx21bp4{flex-direction:column}";
const _ = "._1e0c1txw{display:flex}";
const siteSelectorContainer = null;
const siteSelectorFooterAndPrivacyContainer = null;
export const SiteSelector = _ref => {
  let {
    appDetails,
    links,
    onClose,
    appCompatibilities,
    mpacBaseUrl,
    stargateBasePath,
    installAppHrefResolver,
    requestAppHrefResolver,
    hidePrivacyContainerAndSiteFooter,
    onChange,
    onSiteSelectorFooterInstallCTAClick
  } = _ref;
  const {
    availableSitesPromise,
    appInstallPermissionPromise,
    selectedSiteAndProduct,
    installedAppDetailsPromise,
    onSiteChange,
    hostStatusPromise
  } = useOneClickInstallSiteSelector(appDetails.appKey, appCompatibilities, stargateBasePath, onChange);
  const {
    availableSitesPending
  } = availableSitesPromise;
  const {
    appInstallPermissionResult,
    appInstallPermissionPending
  } = appInstallPermissionPromise;
  const isDataLoading = availableSitesPending || appInstallPermissionPending;
  const isFreeApp = appDetails.paymentModel === MarketplaceAppPaymentModel.Free;
  const {
    installedAppDetailsResult
  } = installedAppDetailsPromise;
  const installedAppDetails = installedAppDetailsResult === null || installedAppDetailsResult === void 0 ? void 0 : installedAppDetailsResult.marketplaceStore.installedAppDetails;
  const isAppInstalled = isFreeApp ? installedAppDetails === null || installedAppDetails === void 0 ? void 0 : installedAppDetails.installed : (installedAppDetails === null || installedAppDetails === void 0 ? void 0 : installedAppDetails.installed) && (installedAppDetails === null || installedAppDetails === void 0 ? void 0 : installedAppDetails.licenseActive);
  const canUserInstallApp = appInstallPermissionResult === AppInstallPermission.CAN_INSTALL_FREE_AND_PAID || isFreeApp && appInstallPermissionResult === AppInstallPermission.CAN_INSTALL_FREE_ONLY;
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_, _2, _3, _4, _5]
    }), /*#__PURE__*/_jsxs("div", {
      className: ax(["_1e0c1txw _2lx21bp4 _4t3ioskh _1bah1yb4 _10m4frkr _1vdkkb7n _1wznf1ug _zp8115vq _1mbp15vq _2oz42wrg _ue5gf5zk _4ap3r01l"]),
      style: {
        "--_7ouv5q": ix("var(--ds-space-100, 8px)".concat(" ", "var(--ds-space-100, 8px)", " 0 0")),
        "--_1kctt8h": ix("var(--ds-space-300, 24px)".concat(" ", "var(--ds-space-300, 24px)", " 0 0"))
      },
      children: [/*#__PURE__*/_jsx(SiteSelectorSelect, {
        appDetails: appDetails,
        isFreeApp: isFreeApp,
        canUserInstallApp: canUserInstallApp,
        availableSitesPromise: availableSitesPromise,
        appInstallPermissionPromise: appInstallPermissionPromise,
        firstCompatibleProduct: appCompatibilities[0],
        mpacBaseUrl: mpacBaseUrl,
        selectedSiteAndProduct: selectedSiteAndProduct,
        onSiteChange: onSiteChange,
        isAppInstalled: isAppInstalled,
        hostStatusPromise: hostStatusPromise,
        installedAppDetailsResult: installedAppDetailsResult,
        supportsTwoStepInstallation: hidePrivacyContainerAndSiteFooter
      }), !hidePrivacyContainerAndSiteFooter && /*#__PURE__*/_jsxs(CC, {
        children: [/*#__PURE__*/_jsx(CS, {
          children: [_6, _7]
        }), /*#__PURE__*/_jsxs("div", {
          className: ax(["_1yt41ejb _1yagcwrd"]),
          style: {
            "--_1ocxs6l": ix("var(--ds-space-300, 24px)".concat(" ", "var(--ds-space-1000, 80px)"))
          },
          children: [/*#__PURE__*/_jsx(InstallableAppPrivacyInformation, {
            links: links,
            appIdentifier: appDetails.appIdentifier,
            appName: appDetails.appName,
            deploymentType: appDetails.deploymentType,
            partner: appDetails.partner,
            privacyPolicyUrl: appDetails.privacyPolicyUrl,
            endUserLicenseAgreementUrl: appDetails.endUserLicenseAgreementUrl
          }), /*#__PURE__*/_jsx(SiteSelectorFooter, _objectSpread(_objectSpread({}, getInstallCTALabelAndHref(isFreeApp, canUserInstallApp, installAppHrefResolver, requestAppHrefResolver, selectedSiteAndProduct, installedAppDetails === null || installedAppDetails === void 0 ? void 0 : installedAppDetails.paidLicenseActiveOnParent)), {}, {
            isLoading: selectedSiteAndProduct ? isDataLoading : false,
            onClose: onClose,
            isInstallCTADisabled: !selectedSiteAndProduct || isAppInstalled,
            canUserInstallApp: canUserInstallApp,
            onSiteSelectorFooterInstallCTAClick: onSiteSelectorFooterInstallCTAClick
          }))]
        })]
      })]
    })]
  });
};